import FieldProject from "../../../generic/entity/project/project"
import FieldConfig from "../../../../fields3/proto/field-config"
import FieldProjectParent_Editable from "./render/editable/editable"

export default class FieldProjectParent extends FieldProject {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Project Parent";

        this.renderComponents.editable = FieldProjectParent_Editable
    }

    getViewValue(model:any) {
        // hm a pochemu v model netuy ?
        return model[this.fieldId] ? model[this.fieldId] : gd.session.projects.get(model.id)!.parentId;
    }

    getDisplayValue(parentId:any) {
        const project = gd.session.projects.get(parentId)

        return project?.name || 'No parent'
    }
}